export const MaxAvatarImageFileSizeBytes: number = 2097152; // 2MB
